import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "./components/sections/Navbar";
import Hero from "./components/sections/Hero";
import About from "./components/sections/About";
import Services from "./components/sections/Services";
import BonCadeau from "./components/sections/BonCadeau";
import Testimonials from "./components/sections/Testimonials";
import Contact from "./components/sections/Contact";
import Footer from "./components/sections/Footer";

const Home = () => {
    return (
        <div className="App bg-cream text-ink" data-testid="home-page">
            <Navbar />
            <main>
                <Hero />
                <About />
                <Services />
                <BonCadeau />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
            <Toaster
                position="bottom-center"
                richColors
                toastOptions={{
                    style: {
                        background: "#FDFBF7",
                        color: "#2A2726",
                        border: "1px solid #E8E2D9",
                        fontFamily: "Manrope, sans-serif",
                    },
                }}
            />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
